 
// ================== LOGIN/LOGOUT ==================== //
import { Login } from './Login'; 



 
// ================== LIST ==================== //
import { AddConvidado } from './list/AddConvidado'; 
import { AddConvite } from './list/AddConvite'; 

import { ListConvidado } from './list/ListConvidado';
import { ListConvite } from './list/ListConvite';
import { ListConviteId } from './list/ListConviteId';
import { ValidarConvite } from './list/ValidarConvite';

 


 


const Api = {
AddConvidado,
AddConvite,
ListConvidado,
ListConvite,
ListConviteId,
ValidarConvite,

  Login, 
 





  
  };


export default Api;